// src/pages/RE/REG910F2.jsx 무작위 부여군 생성

import React, {useEffect, useState} from 'react';

import Button from "components/Button/Button";
import SelectBox from "components/SelectBox/SelectBox";
import SwitchGroup from "components/Button/SwitchGroup";
import {postData} from "utils/TransactionUtil";
import styleCom from "../RE/REGCOM.module.scss";
import Table from "../../components/Table/Table";
import InputUnitText from "components/InputText/InputUnitText";
import toast from "../../components/Toast/Toast";

import Modal from "components/Modal/Modal";
import MSN001F1 from "pages/MS/MSN001F1";



const REG910F2 = ({handle_Close,  comHandleClick_Save}) => {

    const [userDtl, setUserDtl] = useState({
        randId:"", userNm:"", hsptCd:"", roleId:""
    });


    // useEffect(() => {
    // }, []);
    useEffect(() => {
        //(공통) 모달 창 "확인(적용)" 버튼 클릭
        comHandleClick_Save(() => {
            if(userDtl.randId === '' || userDtl.hsptCd === '' || userDtl.randId.length < 1){
                toast({ type: 'info', message: '사용자를 선택하여 주십시오.'});
                return;
            }
            if (!String(userDtl.roleId).trim().startsWith('2')) {
                toast({ type: 'warning', message: '등록 권한이 없는 사용자입니다.'});
                return;
            }

            svcGenUser();
        });
    }, [comHandleClick_Save]);


    //const [chkUserDtl, setChkUserDtl] = useState(userDtl);

    const [isModalschUser, setIsModalschUser] = useState(false); //암호초기화

    //사용자 조회 팝업 닫기
    const handleModalschUser_Close = (userId, userNm, hsptCd, roleId) => {
        if(userId !== undefined && userId !== ""  ){
            setUserDtl({...userDtl, randId: userId, userNm:userNm, hsptCd: hsptCd, roleId:roleId});
        }
        setIsModalschUser(false);
    }


    const btnClick_schUser = () => {
        setIsModalschUser(true);
    }


    /* Call Service====================================================================================================*/

    async function svcGenUser() {
        //무작위군 생성
        let result = await postData("/REW/addRandomGen", userDtl);
        toast({ type: 'info', message: '적용이 완료되었습니다.'});
        handle_Close();

    }



    return(
        <main>
            <div style={{display:"flex",justifyContent:"flex-end", marginBottom:"10px"}}>


            </div>
            <div className={styleCom.main_wrap} style={{marginBottom: "10px"}}>
                <div className={styleCom.title_wrap} style={{marginTop: "10px", color:"gray"}}>
                    * 사용자 검색 버튼을 이용하여 선택 후 생성 버튼을 클릭하여 주십시오.
                </div>
                <Table variant='default' rowCnt={2} colSize={['25%', '75%']} rowSize={'56px'}>
                    <div>사용자 ID</div>
                    <div>
                        <InputUnitText
                            type="text"
                            name="randId"
                            value={userDtl.randId}
                            readOnly={true}
                        />
                        <Button variant="Secondary" size="md" addStyle={{width: "100px", height: "35px"}}
                                onClick={() => btnClick_schUser()}>사용자 검색 </Button>
                    </div>
                    <div>사용자명</div>
                    <div>
                        <InputUnitText
                            type="text"
                            name="userNm"
                            value={userDtl.userNm}
                            onChange={e => setUserDtl({...userDtl, userNm: e.target.value})}
                            readOnly={true}
                        />
                    </div>

                </Table>
            </div>
            <Modal
                open={isModalschUser}
                handle_Close={() => handleModalschUser_Close()}
                title="사용자정보 조회"
                width="800px"
                height="600px"
                isHeader={true}
                //bottomBtnText={{cancel:"취소텍스트",confirm:"확인 텍스트"}}
                bottomBtnText={{cancel: "취소", confirm: "확인"}}
                isBottom={true}>
                <MSN001F1 handle_Close={handleModalschUser_Close}

                />
            </Modal>
        </main>
    )
}
export default REG910F2;